import React from 'react';
import PlayersFilter from './Filters/PlayersFilter';

function LoadMorePlayers(playerLimitSetter) {
  return (
    <div style={{ padding: '10px' }}>
      <button
        onClick={() => playerLimitSetter.playerLimitSetter(0)}
        className="button button--primary-blue load-more-players"
      >
        SE MER
      </button>
    </div>
  );
}
export default LoadMorePlayers;
